import type { TokenInfo } from '../users/types'
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser'
import { useAccount, useMsal } from '@azure/msal-react'
import { useEffect, useState } from 'react'
import { logger } from '../common/logger'
import { env } from '../environment/env'

export function useTokenInfo(): TokenInfo | null {
  const { instance, inProgress, accounts } = useMsal()
  const account = useAccount()
  const [tokenInfo, setTokenInfo] = useState<TokenInfo | null>(null)

  useEffect(() => {
    const fetchTokenInfo = async () => {
      if (account && inProgress === InteractionStatus.None) {
        const request = {
          scopes: [env.AUTH_MSENTRAID_BFF_API_SCOPE],
        }
        const tokenResponse = await instance.acquireTokenSilent(request)
        setTokenInfo({
          tokenType: tokenResponse.tokenType,
          accessToken: tokenResponse.accessToken,
        })
      }
    }
    fetchTokenInfo()
      .catch((error) => {
        logger.logError(error as Error)
        console.error('Error acquiring user access token', account, error)
        if (error instanceof InteractionRequiredAuthError) {
          const acc = account ?? accounts[0]
          instance
            .acquireTokenRedirect({ account: acc, scopes: [] })
            .catch((error) => {
              logger.logError(error as Error)
              console.error('Error acquiring user access token via redirect', account, error)
            })
        }
      })
  }, [instance, account, inProgress, accounts])
  return tokenInfo
}
